import SectionDivider from "./common/SectionDivider";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {subject_options} from "../data/data";
import SubmitSuccessDialog from "./SubmitSuccessDialog";
import {useRef, useState} from "react";
import {Dropdown} from "flowbite-react";
import ArrowDown from "./common/ArrowDown";
import * as emailjs from "@emailjs/browser";

function SendMessageSection() {
    const {t} = useTranslation();
    const formRef = useRef(null)
    const [subject, setSubject] = useState(subject_options[0])
    const [showDialog, setShowDialog] = useState(false)

    const fieldOptions = {
        name: {required: true, message: "name_message"},
        email: {required: true, message: "email_message"},
        phone: {required: true, message: "phone_message"},
        subject: {required: true, message: "subject_message"},
    };

    const {register, handleSubmit, formState: {errors}} = useForm();

    const onSendMessage = (data) => {
        console.log(data);

        let template = {
            from_name: data.name,
            subject: t(subject.label),
            from_email: data.email,
            phone: data.phone,
            message: data.message,
        };

        let templateId = t('email_template')
        emailjs.send('service_zsnt6pr', templateId, template, {
            publicKey: '0ZCRD4KV99tuiHBYN',
        }).then(
            (response) => {
                console.log('Send SUCCESS!', response.status, response.text);
                formRef.current.reset();
                setShowDialog(true);
            },
            (error) => {
                console.log('Send FAILED...', error);
            },
        );
    };

    const onCloseDialog = () => {
        setShowDialog(false);
        window.scrollTo({top: 0, behavior: "smooth"});
    }

    return (
        <div className="bg-cover bg-send-message bg-bottom">
            <div className="section bg-primary-light/80">
                <h1>{t("send_message_title")}</h1>
                <SectionDivider/>
                <form ref={formRef}
                    className="form grid max-md:grid-cols-1 grid-cols-2 justify-center max-md:gap-x-4 gap-x-8 gap-y-4 w-full max-md:px-2 px-8"
                    onSubmit={handleSubmit(onSendMessage)}>
                    <div className="form-input">
                        <label htmlFor="name">{t("name_label")}</label>
                        <input type="text" id="name" className="focus:border-primary focus:ring-primary"
                               placeholder={t("name_placeholder")} {...register('name', fieldOptions.name)} />
                        {errors.name && errors.name.type === "required" && (
                            <div className="error-message">{t(fieldOptions.name.message)}</div>
                        )}
                    </div>
                    <div className="form-input">
                        <label htmlFor="email">{t("email_label")}</label>
                        <input type="email" id="email" className="focus:border-primary focus:ring-primary"
                               placeholder={t("email_placeholder")} {...register('email', fieldOptions.email)} />
                        {errors.email && errors.email.type === "required" && (
                            <div className="error-message">{t(fieldOptions.email.message)}</div>
                        )}
                    </div>
                    <div className="form-input">
                        <label htmlFor="phone">{t("phone_label")}</label>
                        <input type="tel" id="phone" className="focus:border-primary focus:ring-primary"
                               placeholder={t("phone_placeholder")} {...register('phone', fieldOptions.phone)} />
                        {errors.phone && errors.phone.type === "required" && (
                            <div className="error-message">{t(fieldOptions.phone.message)}</div>
                        )}
                    </div>
                    <div className="form-input">
                        <label className="text-left">{t("subject_label")}</label>
                        <Dropdown dismissOnClick={true} renderTrigger={() =>
                            <div id="subject" className="w-full h-12 rounded-sm bg-white pl-2.5 pt-2.5 pb-2.5
                                            flex flex-row justify-between items-center">
                                {t(subject.label)}
                                <div className="bg-gray/20 h-12 w-12 flex items-center"><ArrowDown
                                    className="w-4 h-4 ms-4"/></div>
                            </div>
                        }>
                            {subject_options.map((item, index) => (
                                <Dropdown.Item key={index} onClick={() => setSubject(item)}
                                               className="text-left hover:bg-yellow border-0 py-2.5">{t(item.label)}</Dropdown.Item>
                            ))}
                        </Dropdown>
                    </div>
                    <div className="form-input max-md:col-auto col-span-2">
                        <label htmlFor="message">{t("message_label")}</label>
                        <textarea rows="6" id="message"
                                  className="focus:border-primary focus:ring-primary"
                                  placeholder={t("message_placeholder")} {...register('message', fieldOptions.message)} />
                    </div>
                    <div className="max-md:col-auto col-span-2 mt-4">
                        <button type="submit" className="mt-2 text-white bg-secondary-color hover:bg-primary-dark-color
                            font-bold rounded-sm text-2xl px-5 py-2.5 text-center">{t("submit_button")}
                        </button>
                    </div>
                </form>
                <SubmitSuccessDialog
                    open={showDialog}
                    onClose={onCloseDialog}/>
            </div>
        </div>
    )
}


export default SendMessageSection;